import { Injectable } from '@angular/core';
import { ICompanyModel } from './company-info.models';
import { Observable } from 'rxjs';
import { HttpClientRequestService } from '@core/request-services/httpclient.request.services';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';

@Injectable({ providedIn: 'root' })
export class CompanyStoreService {
  constructor(private repo: HttpClientRequestService) {}

  getCompanyInfo(payload: ICompanyModel): Observable<ICompanyModel> {
    const url: string = EndpointConstants.ApiCompanyinfo;
    return this.repo.post(url, payload);
  }
}
